import script from "./InstructionSitniksPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionSitniksPage.vue?vue&type=script&setup=true&lang=js"

import "./InstructionSitniksPage.vue?vue&type=style&index=0&id=3cbeb697&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cbeb697"]])

export default __exports__